"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RgbColor = void 0;
const rbgRound = (value) => Math.min(Math.floor(value * 256), 255);
const hex2 = (n) => n.toString(16).padStart(2, '0');
const HEX_REGEX = /^#([0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i;
const RGB_REGEX = /^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?\)$/i;
class RgbColor {
    static fromString(str) {
        const hex = HEX_REGEX.exec(str);
        if (hex) {
            const h = hex[1];
            if (h.length === 3) {
                return new RgbColor(parseInt(h[0] + h[0], 16) / 255, parseInt(h[1] + h[1], 16) / 255, parseInt(h[2] + h[2], 16) / 255);
            }
            return new RgbColor(parseInt(h.slice(0, 2), 16) / 255, parseInt(h.slice(2, 4), 16) / 255, parseInt(h.slice(4, 6), 16) / 255, h.length === 8 ? parseInt(h.slice(6, 8), 16) / 255 : 1);
        }
        const rgb = RGB_REGEX.exec(str);
        if (rgb) {
            return new RgbColor(parseInt(rgb[1]) / 255, parseInt(rgb[2]) / 255, parseInt(rgb[3]) / 255, rgb[4] !== undefined ? parseFloat(rgb[4]) : 1);
        }
        return;
    }
    constructor(
    /** Float in range 0 to 1. */
    r, 
    /** Float in range 0 to 1. */
    g, 
    /** Float in range 0 to 1. */
    b, 
    /** Float in range 0 to 1. */
    a = 1) {
        this.r = r;
        this.g = g;
        this.b = b;
        this.a = a;
    }
    u8() {
        return [rbgRound(this.r), rbgRound(this.g), rbgRound(this.b), rbgRound(this.a)];
    }
    hex() {
        const [r, g, b, a] = this.u8();
        const base = '#' + hex2(r) + hex2(g) + hex2(b);
        return a === 255 ? base : base + hex2(a);
    }
    rgb() {
        const [r, g, b] = this.u8();
        return 'rgb(' + r + ',' + g + ',' + b + ')';
    }
    rgba() {
        const [r, g, b] = this.u8();
        return 'rgba(' + r + ',' + g + ',' + b + ',' + +this.a.toFixed(5) + ')';
    }
    toString() {
        return this.hex();
    }
}
exports.RgbColor = RgbColor;
